export const DASHBOARD_SEGMENTED_GROUP_BASE =
  'inline-flex w-full items-center justify-between gap-1 rounded-full border border-[color:var(--color-border-subtle)] bg-[color:var(--ib-surface-card)] p-1 shadow-[var(--shadow-elev-1)]';

export const DASHBOARD_SEGMENTED_BUTTON_BASE =
  'flex-1 inline-flex items-center justify-center gap-1 rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-300 md:text-xs';

export const DASHBOARD_SEGMENTED_BUTTON_ACTIVE =
  'ib-streak-pill-tab-active border-[color:var(--color-border-soft)] bg-[color:var(--color-surface)] text-[color:var(--color-accent-primary)] shadow-[var(--shadow-elev-1)] dark:border-white/90 dark:bg-white dark:text-black';

export const DASHBOARD_SEGMENTED_BUTTON_INACTIVE =
  'border-transparent bg-transparent text-[color:var(--color-text-muted)] hover:text-[color:var(--color-text)]';
